<template>
  <div class="center">
    <!-- 返回按键 -->
    <!-- 返回键 -->
    <div class="back_viwe">
      <div class="back" @click="back()">
        <i class="el-icon-back"></i>
        <span>返回</span>
      </div>
      <!-- 下载按钮 -->
      <el-button type="primary" @click="clickPdf">下载页面</el-button>
    </div>
    <!-- 主体部分 -->
    <div class="mian_view" id="pdfDom">
      <!-- 标题 -->
      <div class="title_view">
        <div>
          <h2>{{ hospitalName }}</h2>
          <h2>"{{ ExamList.ExamName }}"试卷成绩报告</h2>
        </div>
      </div>
      <!-- 1.报告说明 -->
      <Declare ref="Declare" :ExamList="ExamList" />
      <!-- 3.个人考试排名 -->
      <Ranking ref="Ranking" />
      <!-- 4.科室考试情况 -->
      <Department ref="Department" />
    </div>
    <!-- 6.表格 -->
    <div class="error_details">
      <h2>6、错误详情分析</h2>
      <p>共{{ detailsData.length }}个错题，按照"错误率"综合排名前10如下</p>
      <div class="select_view">
        <p>分页选择：</p>
        <el-select
          v-model="details"
          placeholder="请选择"
          @change="detailsChang"
        >
          <el-option
            v-for="item in pagingArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="error_table">
      <p class="text">重点错题详单</p>
      <el-table
        :data="detailsData"
        border
        style="width: 100%"
        :height="rolling == true ? 541 : ''"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
          'text-align': 'center',
        }"
      >
        <el-table-column label="序号" type="index" width="100">
        </el-table-column>
        <el-table-column label="题干" prop="Title1">
          <template slot-scope="scope">
            <p
              v-html="
                scope.row.Title1 != undefined
                  ? isreferimg(scope.row.Title1, scope.row.ID)
                  : isreferimg(scope.row.MainTitle, scope.row.ID)
              "
            ></p>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in detailsColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Declare from "./Declare.vue";
import Ranking from "./Ranking.vue";
import Department from "./Departments.vue";
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import { zhuanhuan } from "@/utils/validata.js";
import { saveAs } from "file-saver";
import * as JSZip from "jszip";
export default {
  props: ["cutcoms"],
  data() {
    return {
      statePopupstatus: {},
      ExamList: {}, // 接口一
      hospitalName: "", // 医院名称
      rolling: true,
      threeData: [],
      fourData: [],
      parameter: {},
      fiveData: [],
      sixData: [],
      newArr: [],
      detailsData: [], // 错误详情
      details: "null", // 详情
      detailsColumns: [
        {
          prop: "Style",
          label: "题型",
        },
        {
          prop: "errCount",
          label: "答题错误人次",
        },
        {
          prop: "AlreadyStuCount",
          label: "答题人次",
        },
        {
          prop: "cwl1",
          label: "错误率(%)",
        },
      ],
      pagingArr: [
        {
          value: "null",
          label: "全部",
        },
        {
          value: "10",
          label: "10",
        },
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        },
      ],
      fileArr: [],
      base64Arr: [],
    };
  },
  components: {
    Declare,
    Ranking,
    Department,
  },
  methods: {
    back() {
      // this.cutcoms(0);
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path:this.$route.query.toUrl,
          query: {
            trainId: this.$route.query.trainId,
            toUrl: this.$route.query.toUrl,
            state:'xxqk'
          },
        });
      } else {
        this.cutcoms(0);
      }
      this.$destroy();
    },
    // 获取1和2接口
    async getExamList() {
      const { data } = await systemclass.examReport1(this.parameter);
      if (data.Status == 200) {
        this.ExamList = data.Data[0];
        this.ExamList.TestCount = data.Data[0].TestCount + "题";
        this.ExamList.SpendTime = data.Data[0].SpendTime + "分钟";
        await this.$refs.Declare.fn();
        await this.$refs.Declare.reportData();
        this.hospitalName = JSON.parse(
          localStorage.getItem("userlist")
        ).hidName;
        // console.log(this.ExamList, "列表数据");
      } else {
        this.$message.error(data.Data);
      }
    },
    // 接口三
    async getRanKingData() {
      const { data } = await systemclass.examReport3(this.parameter);
      if (data.Status == 200) {
        this.threeData = JSON.parse(JSON.stringify(data.Data));
        this.$refs.Ranking.changPaging("null");
        // this.$refs.Ranking.ranData = data.Data;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 接口四
    async getDepatments() {
      const { data } = await systemclass.examReport4(this.parameter);
      if (data.Status == 200) {
        data.Data.map((item) => {
          this.$set(item, "cyl1", item.cyl + "%");
          this.$set(item, "jgl1", item.jgl + "%");
        });
        this.fourData = JSON.parse(JSON.stringify(data.Data));
        this.$refs.Department.changPaging("null"); // 页码
        this.$refs.Department.filterData(); // 过滤未参与考试的
        await this.$refs.Department.reportData(); // echats
        // console.log(data, "第四步");
      } else {
        this.$message.error(data.Data);
      }
    },
    // 接口五
    async getJobsData() {
      const { data } = await systemclass.examReport5(this.parameter);
      if (data.Status == 200) {
        data.Data.data.map((item) => {
          this.$set(item, "cyl1", item.cyl + "%");
        });
        this.fiveData = JSON.parse(JSON.stringify(data.Data.data));
        this.$refs.Department.jbsChang("null"); // 页码
        await this.$refs.Department.jobsReportData(); // echats
      } else {
        this.$message.error(data.Data);
      }
    },
    // 接口六
    async getDetailsData() {
      const { data } = await systemclass.examReport6(this.parameter);
      if (data.Status == 200) {
        // console.log(test.length, "原始数据的长度");
        data.Data.forEach((item) => {
          try {
            item.TestJSON = JSON.parse(item.TestJSON);
          } catch (error) {
            if (String(error).includes("／")) {
              return;
            }
            item.TestJSON = JSON.parse(item.TestJSON.replace(/[‘]|[""]/g, '"'));
          }
          if (item.TestJSON?.BTestItem) {
            item.key = true; // 发现有子数组加一个唯一标识方便后面过滤
          }
          this.$set(
            item,
            "Title1",
            !item.TestJSON.Title ? item.TestJSON.MainTitle : item.TestJSON.Title
          );
          this.$set(item, "MainTitle", item.TestJSON.MainTitle);
          this.$set(item, "cwl1", item.cwl + "%");

          let specialArr = data.Data.filter((item) => {
            return item.key; //  拿到需要特殊处理的
          });
          specialArr = specialArr.map((item) => {
            return item.TestJSON.BTestItem.map((zitem) => {
              let obj = {
                Style: item.Style,
                errCount: item.errCount,
                Title1: zitem.Title,
                cwl1: item.cwl + "%",
                AlreadyStuCount: item.AlreadyStuCount,
              };
              return obj;
            });
          });
          this.newArr = specialArr.flat(); // 返回所有需要特殊处理好的数组
          let noSpecial = data.Data.filter((item) => {
            return !item.key; // 过滤掉有子数组的对象
          });
          let oldArr = noSpecial.concat(this.newArr);
          this.sixData = oldArr;
          this.detailsChang("null"); // 页码
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    // 详情分页
    detailsChang(a) {
      if (a == "null") {
        this.detailsData = this.sixData;
      } else {
        this.detailsData = this.sixData.slice(0, a);
      }
    },
    fun() {
      console.log(this.fileArr, "sahjedha");
    },
    // 导出 pdf
    async clickPdf() {
      this.rolling = false; // 将数据全部展开
      // 导出规则是当前是展示多少条就导出多少条
      await this.$refs.Ranking.changPaging(this.$refs.Ranking.paging);
      await this.$refs.Department.changPaging(this.$refs.Department.paging);
      // 第三个接口默认全部再导出
      // console.log(document.querySelector("#pdfDom"));
      // 此处视图PDF导出，标题六的表格单独导出
      // this.getPdf("pdfDom", "成绩报告");
      // console.log(this.getPdf("pdfDom", "成绩报告"), "教案设计氨基酸就");
      if (this.detailsData.length > 0) {
        // 当表格有数据的时候导出表格
        this.toGetPdf(1, 0); // 获取pdf地址
        // this.$message({
        //   message: "恭喜你，成绩报告已导出",
        //   type: "success"
        // });
      } else {
        this.toGetPdf(0); // PDF生成直接导出
        this.$message({
          message: "警告，当前表格无数据，只导出PDF成绩报告",
          type: "warning",
        });
      }
      // this.rolling = true; // 收起来
    },
    // PDF下载
    toGetPdf(val = false, download = true) {
      /**
     * val 决定走不走上传接口，默认为不上传给后端
     * download 默认是下载
     * /
      /* */
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0); //这行代码很重要，它让页面的滚动条跳到了最上方如果点击打印按钮的时候,滚动条没有在最上方,打印内容会是不完整的,体验也会差
          let title = "成绩报告单";
          this.getPdf(title, download) //download：false为不下载，这里调用了刚刚引用的全局函数，.then得到的值是base64位的pdf文件
            .then((res) => {
              if (val) {
                // console.log(res, "准备上传");
                let newArr = [
                  {
                    prop: "Title1",
                    label: "题干",
                    width: "300",
                  },
                ];
                newArr = newArr.concat(this.detailsColumns);
                let a = this.$downloadExcel(this.detailsData, newArr, "url");
                let obj1 = {
                  name: "错误详情分析",
                  file: a,
                  suffix: ".xls",
                };
                this.fileArr = []; // 重置
                this.fileArr.push(obj1); // 获取表格地址
                let obj = {
                  name: "成绩报告",
                  file: res,
                  suffix: ".pdf",
                };
                this.fileArr.push(obj);
                this.download(this.fileArr); // 执行打包压缩
                // this.UploadPdf(res);
              } else {
                console.log("不上传");
              }
            });
        }, 1000);
      });
    },

    // 压缩包
    download(arr) {
      const zip = new JSZip(); // 实例化zip
      const img = zip.folder("成绩报告"); // zip包内的文件夹名字
      const fileReader = new FileReader();
      const dataList = arr.map((item) => {
        return new Promise(async (reslove, reject) => {
          let basePic = "";
          if (Object.prototype.toString.call(item.file) === "[object Blob]") {
            fileReader.onload = (e) => {
              basePic = e.target.result.replace(
                /^data:application\/(.*?);base64,/,
                ""
              );
              // 将文件加入到zip包内
              reslove({
                name: "成绩报告1",
                file: basePic,
                suffix: ".xls",
              });
            };
            fileReader.readAsDataURL(item.file);
          } else {
            basePic = item.file.replace(/^data:application\/(.*?);base64,/, "");
            reslove({
              name: "成绩报告",
              file: basePic,
              suffix: ".pdf",
            });
          }
        });
      });

      Promise.all(dataList).then((res) => {
        // 拿到所有处理好的数据去下载
        res.forEach((e) => {
          img.file(e.name + e.suffix, e.file, { base64: true }); // 将  文件加入到zip包内
        });
        zip
          .generateAsync({
            type: "blob",
            compression: "DEFLATE", // STORE：默认不压缩 DEFLATE：需要压缩
            compressionOptions: {
              level: 9, // 压缩等级1~9    1压缩速度最快，9最优压缩方式
              // [使用一张图片测试之后1和9压缩的力度不大，相差100字节左右]
            },
          }) // zip下载
          .then(function (content) {
            // see FileSaver.js
            saveAs(content, "成绩报告单.zip"); // zip下载后的名字
          });
      });

      //   执行下载方法
    },
    // 先后执行接口方法
    async performFunction() {
      this.parameter = {
        examID: this.$parent.examInfo.ExamID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      await this.getExamList();
      this.getRanKingData(); // 接口三
      await this.getDepatments(); // 接口四
      await this.getJobsData(); // 接口五
      await this.getDetailsData(); // 接口六
      this.$refs.Declare.reportData(); // echars
    },
  },
  computed: {
    //图片处理 + 处理
    isreferimg() {
      return function huizhuan(params, id) {
        if (params.indexOf("[Img") == "-1") {
          return params;
        } else {
          let newstr = zhuanhuan(
            params.substr(
              params.indexOf("[Img"),
              params.indexOf(".gif]") - params.indexOf("[Img") + 5
            )
          );
          params = params.replace(
            params.substr(
              params.indexOf("[Img"),
              params.indexOf(".gif]") - params.indexOf("[Img") + 5
            ),
            newstr
          );
          if (params.indexOf("[Img") != "-1") {
            return huizhuan(params, id);
          }
          // 如果试卷ID超过或等于32位 http://customimgt.tibosi.com/hospitalID/XXX.gif
          if (String(id).length >= 32) {
            let imgurl = sessionStorage.getItem("ImgUrl"); // 图片正式还是测试地址
            a = params.replace(
              /\[Img/g,
              `<img src='${imgurl}/${JSON.parse(loginvuex.state.hid)}/`
            );
            return a.replace(/\]/g, "'>");
          }
          return params;
        }
      };
    },
  },
  created() {
    this.performFunction();
  },
  mounted() {
    this.$refs.Declare.reportData(); // 饼状图
    this.$refs.Department.reportData(); // 第四个的柱状图
    this.$refs.Department.jobsReportData(); // echats
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 返回按键css
.back_viwe {
  width: 100%;
  background: #ffff;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  .back {
    width: 100px;
    min-height: 40px;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: #409eff;
      background: #ecf5ff;
    }
    i {
      display: inline-block;
      margin-right: 12px;
      color: #999999;
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
    }
  }
  .el-button {
    //   margin-right: 16px;
    margin: 10px 16px 10px 0px;
  }
}
.mian_view {
  min-height: 740px;
  position: relative;
  background: #ffff;
  padding: 30px;
  .title_view {
    height: 120px;
    // border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      text-align: center;
      h2 {
        &:nth-child(1) {
          margin-bottom: 16px;
        }
      }
    }
  }
}
.error_details {
  padding-left: 30px;
  p {
    margin-bottom: 22px;
    margin-top: 16px;
  }
}
.error_table {
  padding: 30px;
  .text {
    text-align: center;
    margin-bottom: 16px;
    margin-top: 0 !important;
  }
}
.select_view {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  p {
    margin: 0 !important;
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  text-align: center;
}
::v-deep .el-table td.el-table__cell div {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
}
</style>
